export const ServicePricingType = {
  "Ton": "T.",
  "Unit": "szt.",
  "RunningMeter": "mb."
};